import { render } from "./ModalExito.vue?vue&type=template&id=08d74f0d&scoped=true"
import script from "./ModalExito.vue?vue&type=script&lang=js"
export * from "./ModalExito.vue?vue&type=script&lang=js"

import "./ModalExito.vue?vue&type=style&index=0&id=08d74f0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d74f0d"]])

export default __exports__